import { IApiDataProps } from 'shared/consts/types';

export interface IAnalyticsDashboard {
	dashboardId: string;
	dashboardName: string;
	dashboardVertical: string;
	accessible: boolean;
}

export interface IAnalyticsState {
	dashboards: IApiDataProps<Array<IAnalyticsDashboard>>;
	customDashboardName: string;
}

export const analyticsState: IAnalyticsState = {
	dashboards: {
		data: [],
		error: false,
		loading: false,
	},
	customDashboardName: '',
};
